export default "__VITE_ASSET__5a58a279__"